import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from "@material-ui/core/TextField";
import { StepButtons, CurrencyCustom, EWCCCustom } from "../CommonComponents";
import { Consumer } from "./EWCCContext";
import styles from "../ewccstyle";

const CreditCardReference = withStyles(styles)(function(props) {
  const { activeStep, handleBack, classes } = props;
  return (
    <Consumer>
      {context => (
        <Formik
          initialValues={{
            cardIssuer1: context.cardIssuer1,
            cardNumber1: context.cardNumber1,
            memberSince1: context.memberSince1,
            creditLimit1: context.creditLimit1,
            cardIssuer2: context.cardIssuer2,
            cardNumber2: context.cardNumber2,
            memberSince2: context.memberSince2,
            creditLimit2: context.creditLimit2,
            // cardIssuer3: context.cardIssuer3,
            // cardNumber3: context.cardNumber3,
            // memberSince3: context.memberSince3,
            // creditLimit3: context.creditLimit3
          }}
          validationSchema={Yup.object().shape({
            cardIssuer1: Yup.string().max(200,"Text too long"),
            cardIssuer2: Yup.string().max(200,"Text too long"),
            // cardIssuer3: Yup.string().max(200,"Text too long"),
            cardNumber1: Yup.string().matches(/\d\d\d\d-\?\?\?\?-\?\?\?\?-\d\d\d\d/, "Invalid credit card number").max(19,"Text too long"),
            cardNumber2: Yup.string().matches(/\d\d\d\d-\?\?\?\?-\?\?\?\?-\d\d\d\d/, "Invalid credit card number").max(19,"Text too long"),
            // cardNumber3: Yup.string().max(30,"Invalid value"),
            creditLimit1: Yup.string().max(20,"Invalid value"),
            creditLimit2: Yup.string().max(20,"Invalid value"),
            // creditLimit3: Yup.string().max(20,"Invalid value")
          })}
          onSubmit={(values, actions) => {
            context.updateState("cardIssuer1", values.cardIssuer1);
            context.updateState("cardNumber1", values.cardNumber1);
            context.updateState("memberSince1", values.memberSince1);
            context.updateState("creditLimit1", values.creditLimit1);
            context.updateState("cardIssuer2", values.cardIssuer2);
            context.updateState("cardNumber2", values.cardNumber2);
            context.updateState("memberSince2", values.memberSince2);
            context.updateState("creditLimit2", values.creditLimit2);
            // context.updateState("cardIssuer3", values.cardIssuer3);
            // context.updateState("cardNumber3", values.cardNumber3);
            // context.updateState("memberSince3", values.memberSince3);
            // context.updateState("creditLimit3", values.creditLimit3);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {props => {
            const {
              values,
              errors,
              touched,

              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            } = props;

            return (
              <form noValidate autoComplete="off">
                <FormControl fullWidth margin="dense">
                  <FormLabel component="legend">Card 1</FormLabel>

                  <TextField
                    id="cardIssuer1"
                    label="Card Issuer"
                    className={classes.textField}
                    value={values.cardIssuer1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.cardIssuer1 && touched.cardIssuer1
                        ? errors.cardIssuer1
                        : ""
                    }
                    error={
                      errors.cardIssuer1 && touched.cardIssuer1 ? true : false
                    }
                  />
                </FormControl>

                <FormControl
										fullWidth
										margin="dense"
										error={errors.cardNumber1 && touched.cardNumber1 ? true : false}
									>
                    <InputLabel required htmlFor="cardno">Card Number</InputLabel>
										<Input
                      id="cardNumber1"
                      label="Card Number"
											value={values.cardNumber1}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.cardNumber1 && touched.cardNumber1 ? true : false}
											inputComponent={EWCCCustom}
										/>
										<FormHelperText
											margin="dense"
											classes={{
												root: classes.dropdownError,
												error: classes.error,
											}}
											component="p"
										>
											{errors.cardNumber1 && touched.cardNumber1 && (<>{errors.cardNumber1}</>)}
										</FormHelperText>

									</FormControl>






                <FormControl fullWidth margin="dense">
                  <TextField
                    id="memberSince1"
                    label="Member Since"
                    type="date"
                    defaultValue="1970-01-01"
                    value={values.memberSince1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText={
                      errors.memberSince1 && touched.memberSince1
                        ? errors.memberSince1
                        : ""
                    }
                    error={
                      errors.memberSince1 && touched.memberSince1 ? true : false
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="creditLimit1"
                    label="Credit Limit"
                    value={values.creditLimit1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.creditLimit1
                        ? errors.creditLimit1
                        : ""
                    }
                    error={
                      errors.creditLimit1 && touched.creditLimit1 ? true : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom
                    }}
                  />
                </FormControl>

                {/* Card Ref */}

                <br />
                <br />

                <FormControl fullWidth margin="dense">
                  <FormLabel component="legend">Card 2</FormLabel>

                  <TextField
                    id="cardIssuer2"
                    label="Card Issuer"
                    className={classes.textField}
                    value={values.cardIssuer2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.cardIssuer2 && touched.cardIssuer2
                        ? errors.cardIssuer2
                        : ""
                    }
                    error={
                      errors.cardIssuer2 && touched.cardIssuer2 ? true : false
                    }
                  />
                </FormControl>

                {/* <FormControl fullWidth margin="dense">
                  <TextField
                    id="cardNumber2"
                    label="Card Number"
                    className={classes.textField}
                    value={values.cardNumber2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.cardNumber2 && touched.cardNumber2
                        ? errors.cardNumber2
                        : ""
                    }
                    error={
                      errors.cardNumber2 && touched.cardNumber2 ? true : false
                    }
                  />
                </FormControl> */}

                  <FormControl
										fullWidth
										margin="dense"
										error={errors.cardNumber2 && touched.cardNumber2 ? true : false}
									>
                    <InputLabel required htmlFor="cardno">Card Number</InputLabel>
										<Input
                      id="cardNumber2"
                      label="Card Number"
											value={values.cardNumber2}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.cardNumber2 && touched.cardNumber2 ? true : false}
											inputComponent={EWCCCustom}
										/>
										<FormHelperText
											margin="dense"
											classes={{
												root: classes.dropdownError,
												error: classes.error,
											}}
											component="p"
										>
											{errors.cardNumber2 && touched.cardNumber2 && (<>{errors.cardNumber2}</>)}
										</FormHelperText>

									</FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="memberSince2"
                    label="Member Since"
                    type="date"
                    defaultValue="1970-01-01"
                    value={values.memberSince2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText={
                      errors.memberSince2 && touched.memberSince2
                        ? errors.memberSince2
                        : ""
                    }
                    error={
                      errors.memberSince2 && touched.memberSince2 ? true : false
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="creditLimit2"
                    label="Credit Limit"
                    value={values.creditLimit2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                       touched.creditLimit2
                        ? errors.creditLimit2
                        : ""
                    }
                    error={
                      errors.creditLimit2 && touched.creditLimit2 ? true : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom
                    }}
                  />
                </FormControl>


                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

export default CreditCardReference;
